export enum Variants {
  default = 'default',
  v1 = 'v1',
  variation_1 = 'variation_1',
  variation_2 = 'variation_2',
  variation_3 = 'variation_3'
}
